module.exports = __webpack_public_path__ + "static/media/iconLostObject.5d806f94.svg";